import { useEffect, useState } from 'react';
import { helpdeskApi, type HelpdeskTicketDto } from '../api/helpdesk';
import { HD_STATUS } from './HelpdeskPage';
import { ticketCodeLabel } from './ticket-code';
import './helpdesk-embed.css';

function fmtDate(iso: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleDateString('cs-CZ');
}

export function HelpdeskTicketsEmbed({ email }: { email: string | null | undefined }) {
  const [tickets, setTickets] = useState<HelpdeskTicketDto[] | null>(null);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (!email) { setTickets([]); return; }
    let alive = true;
    helpdeskApi.ticketsByEmail(email)
      .then((r) => { if (alive) setTickets(r.tickets); })
      .catch(() => { if (alive) setHidden(true); }); // no helpdesk access → hide quietly
    return () => { alive = false; };
  }, [email]);

  if (hidden || !email) return null;

  return (
    <div className="hde-card">
      <div className="hde-title">Helpdesk tickety {tickets ? `(${tickets.length})` : ''}</div>
      {tickets === null && <div className="hde-empty">Načítám…</div>}
      {tickets && tickets.length === 0 && <div className="hde-empty">Žádné tickety pro tento e-mail.</div>}
      {tickets && tickets.length > 0 && (
        <ul className="hde-list">
          {tickets.map((t) => {
            const st = HD_STATUS[t.status] ?? { label: t.status, color: '#6c6c70' };
            return (
              <li key={t.id} className="hde-row">
                <span className="hde-code">{ticketCodeLabel(t)}</span>
                <span className="hde-subject">{t.subject}</span>
                <span className="hde-badge" style={{ color: st.color, background: `${st.color}1f` }}>{st.label}</span>
                <span className="hde-date">{fmtDate(t.lastMessageAt ?? t.createdAt)}</span>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
